// setting the process global var here so webpack-dev-server and cypress don't throw
// errors saying "process" is undefined. When we yarn build [app] they ARE defined
(window as any).process = { env: {} }; // this does not affect staging|production in any way
(window as any).global = window;
